(function ($) {

    const selectors = {
        slider: '.slider',
        wrapper: '.wrapper',
        content: '.slick-active .slider__wrap',
        next_btn: '.slick-next',
        prev_btn: '.slick-prev'

    };

    const classes = {
        wrapper: 'wrapper',
        slider: '.slider',
    };

    const slider = {
        init: function () {
            $(selectors.slider).slick({
                infinite: true,
                slidesToScroll: 1,
                draggable: false,
                adaptiveHeight: true
            });
        },
    };
    jQuery(document).ready(() => {
        if ($(selectors.wrapper).find(classes.slider).length) {
            $(selectors.wrapper).removeClass('wrapper__column');
        }
        slider.init();
    });
})(jQuery);



